import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../../../components/Loader";
import InnerBannerBreadcrumb from "../../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../../../redux/services/apiSlice";
import {
  convertDateFormat,
  convertStringToArray,
  getLatestDateFromData,
} from "../../../../Utils/utils";
import PublicationCard from "../../../../components/PublicationCard";
import { useLanguageTranslation } from "../../../../hooks/useLanguageTranslation";
import PageLastUpdated from "../../../../components/shared/PageLastUpdated";
import { useMemo } from "react";

const PublicationDetailById = () => {
  const { getText } = useLanguageTranslation();
  const navigate = useNavigate();
  const { languageType } = useSelector((state) => state.homeSlice);

  const { nid } = useParams();
  const { data: publicationsData = [], isLoading: publicationsIsLoading } =
    useGetProtectedApiDataQuery({ url: "publication", lang: languageType });

  const publicationDetail = publicationsData.find((item) => item.nid === nid);
  const publicationLastDate = publicationsData.filter(
    (item) => item.nid === nid,
  );

  console.log(publicationDetail);

  const pdfData = convertStringToArray(
    publicationDetail?.field_publications_document,
  );
  console.log({ pdfData });

  const handlePublicationClick = (item) => {
    if (item.file_path === "") {
      navigate(`/publication-detail/${item.nid}`);
    } else {
      window.open(
        `${process.env.REACT_APP_IMAGE_URL}/${item.file_path}`,
        "_blank",
        "noopener,noreferrer",
      );
    }
  };

  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(publicationLastDate);
  }, [publicationLastDate]);

  if (publicationsIsLoading) {
    return <Loader />;
  }

  if (!publicationDetail) {
    return <div>Publication not found</div>;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="/images/inner_aboutbann.jpg"
        title={getText("News Room & Media", "समाचार मीडिया")}
        titleLink="/publication-detail"
        titleLink2="/publication-detail"
        levelTwo={true}
        levelThree={true}
        titleTwo={getText("Publications", "प्रकाशन")}
        titleThree={publicationDetail.title}
        isActive={publicationDetail.title}
      />
      <div className="inner-container">
        <div className="container">
          <section className="ourCompany">
            <div className="container">
              <div className="row mb-5">
                {pdfData.map((publicationItem, index) => (
                  <div
                    className="col-12 col-sm-12 col-md-3 col-lg-3 mvDescWrap mb-3"
                    key={index}
                  >
                    <div className="photo-gallery-area desc-sec photo-gallery-detail-page publicationslist">
                      <div className="card-sec">
                        <div
                          className="img-sec"
                          onClick={(e) =>
                            handlePublicationClick(publicationItem)
                          }
                        >
                          <a
                            // href={`${process.env.REACT_APP_IMAGE_URL}/${publicationItem?.field_covid_document}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={`${process.env.REACT_APP_IMAGE_URL}/${publicationDetail?.nothing}`}
                              alt={publicationItem.title}
                            />
                          </a>
                        </div>
                        <div className="pdf-link">
                          <a
                            // href={`${process.env.REACT_APP_IMAGE_URL}/${publicationItem?.field_covid_document}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src="./images/pdf-icon.png"
                              alt="PDF-Icon"
                              className="mr-2"
                            />
                          </a>
                        </div>
                        <div className="desc-sec">
                          <div>
                            <span className="date">
                              {convertDateFormat(
                                publicationItem?.field_date_of_publication,
                              )}
                            </span>

                            {publicationItem?.field_publication_vol && (
                              <span className="vol-txt">
                                {publicationItem.field_publication_vol}
                              </span>
                            )}
                          </div>
                          <p>
                            {
                              publicationItem.title
                              // .slice(0, 20)
                            }
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default PublicationDetailById;
